<template lang="pug">
div
    .box
        .box-header.dker
            h3
                span(v-if="!hasFinalized") Stock Receive - Step 2 of 3
                span(v-else) Stock Receive - Step 3 of 3

        .box-divider.m-a-0.p-a-0

        .box-body
            .p-a
                step-wizard(:status="stockReceive.status")

        .box-header
            h3 General

        .box-divider.m-a-0.p-a-0

        .box-body
            .row
                .col-sm-6
                    table.table.table-borderless
                        tr
                            td._500 Reference Id
                            td {{ stockReceive.reference_id }}

                        tr
                            td._500 Name
                            td
                                .form-group
                                    input.form-control.w-lg(
                                        :class="{ 'has-error': errors.has('name') }"
                                        v-show="canUpdate && !hasFinalized",
                                        type="text",
                                        name="name",
                                        v-validate="'required'",
                                        :value="stockReceive.name",
                                        @input="setStockReceiveAttr({ key: 'name', value: $event.target.value })"
                                    )

                                span(v-show="!canUpdate || hasFinalized") {{ stockReceive.name }}

                        tr
                            td._500 Status
                            td
                                span.label.hidden-print(
                                    :class="{'yellow': ! hasFinalized, 'success': hasFinalized}"
                                )
                                    strong {{  completionStatus }}

                .col-sm-6
                    table.table.table-form-input
                        tr
                            td._500 Receive Date
                            td
                                vue-datepicker(
                                    v-show="canUpdate && !hasFinalized",
                                    type="datetime"
                                    v-model="receiveDate",
                                    lang="en",
                                    :editable="false",
                                    :clearable="false",
                                    :shortcuts="false",
                                    format="DD/MM/YYYY hh:mm:ss a"
                                    :time-picker-options="{ start: '00:00', step: '00:30', end: '23:30' }"
                                )
                                span(v-show="!canUpdate || hasFinalized") {{ formattedDate(receiveDate) }}

                        tr
                            td._500 Destination Outlet
                            td {{ outlet.name }}

                        tr
                            td._500 Supplier
                            td {{ supplier.name }}

                        tr
                            td._500 General Notes
                            td
                                textarea.form-control(
                                    rows="3",
                                    :value="stockReceive.description",
                                    v-if="! hasFinalized && canUpdate",
                                    @input="setStockReceiveAttr({ key: 'description', value: $event.target.value })"
                                )
                                span(v-else) {{ stockReceive.description }}

</template>

<script>
import { mapGetters, mapState, mapActions } from 'vuex';
import stepWizard from './stock-receive-step.vue';
import stockReceiveMixin from './stock-receive-mixin';

export default {
    inject: ['$validator'],

    components: { stepWizard },

    mixins: [stockReceiveMixin],

    computed: {
        ...mapState('stockReceive', ['stockReceive']),

        ...mapGetters('stockReceive', [
            'outlet',
            'stockReceive',
            'supplier',
            'completionStatus',
            'hasFinalized',
        ]),

        receiveDate: {
            get() {
                return this.stockReceive.receive_date;
            },
            set(datetime) {
                const value = moment(datetime).format();
                this.setStockReceiveAttr({ key: 'receive_date', value });
            },
        },
    },

    methods: {
        ...mapActions('stockReceive', ['setStockReceiveAttr']),
    },
};
</script>



// WEBPACK FOOTER //
// resources/assets/js/components/stock_receive/stock-receive-edit-info.vue